import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './StorageSolution.css';

const products = [
  {
    name: "Rackings",
    description: "Our Rackings solutions are designed to provide robust, efficient storage solutions. Perfect for warehouses and industrial spaces, our racking systems enhance space utilization, organize inventory, and provide easy access to stored materials. These durable racks are engineered to handle heavy loads and stand the test of time, ensuring safety and efficiency in every application.",
    main360Image: 'https://via.placeholder.com/300/FFCC00/FFFFFF?text=360+View',
    additionalImages: [
      require('../../../assets/Hanging Rack - SSKV-05.JPG'),
      require('../../../assets/Hanging Rack - SSKV-07.JPG'),
      require('../../../assets/90 - upright -Rack.JPG'),
      require('../../../assets/rackings.jpeg')
    ],
    videoLink: 'https://www.w3schools.com/html/mov_bbb.mp4'
  },
  {
    name: "Material Handling",
    description: "Our Material Handling equipment is crafted for efficiency and durability, enabling the seamless movement, protection, storage, and control of materials in manufacturing, distribution, and warehouse environments. These tools streamline workflows, improve safety, and optimize productivity in both small and large-scale operations.",
    main360Image: 'https://via.placeholder.com/300/007ACC/FFFFFF?text=360+View',
    additionalImages: [
      require('../../../assets/3A Stacker.jpg'),
      require('../../../assets/diesel forklift 50 ton.jpg')
    ],
    videoLink: 'https://www.w3schools.com/html/mov_bbb.mp4'
  },
  {
    name: "Hydraulics Lift",
    description: "Our Hydraulic Lift solutions provide reliable lifting capabilities, designed for versatility and strength in various applications, including industrial, automotive, and construction settings. Engineered for smooth and controlled lifting, these systems ensure safety and ease of use, meeting rigorous industry standards for performance and durability.",
    main360Image: 'https://via.placeholder.com/300/007ACC/FFFFFF?text=360+View',
    additionalImages: [
      require('../../../assets/xlpe.png'),
      require('../../../assets/foam.jpg'),
      require('../../../assets/foam.png')
    ],
    videoLink: 'https://www.w3schools.com/html/mov_bbb.mp4'
  },
];

  

const StorageSolution = () => {
  const initialProductStates = products.map((product) => ({
    selectedImage: product.main360Image,
    isVideo: false,
  }));

  const [productStates, setProductStates] = useState(initialProductStates);


  useEffect(() => {
    if (productStates.length !== products.length) {
      setProductStates(initialProductStates);
    }
  }, [productStates, products, initialProductStates]);

  const handleVideoClick = (index) => {
    setProductStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, isVideo: true, selectedImage: null } : state
      )
    );
  };

  const handleImageClick = (image, index) => {
    setProductStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, selectedImage: image, isVideo: false } : state
      )
    );
  };

  return (
    <div className="ventilation-container">
      {products.map((product, index) => (
        <motion.div
          key={index}
          className={`product-section ${product.name.toLowerCase().replace(" ", "-")}`}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.4 }}
        >
          <motion.h1 
            className="product-title" 
            initial={{ scale: 0.8, opacity: 0 }} 
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
          >
            {product.name}
          </motion.h1>
          <div className="product-content">
            <div className="thumbnail-section">
              {product.additionalImages.map((image, i) => (
                <motion.img
                  key={i}
                  src={image}
                  alt={`${product.name} view ${i + 1}`}
                  className={`thumbnail ${productStates[index]?.selectedImage === image ? 'active' : ''}`}
                  onClick={() => handleImageClick(image, index)}
                  whileHover={{ scale: 1.15 }}
                  transition={{ duration: 0.3 }}
                />
              ))}
              <motion.button
                className="video-button"
                onClick={() => handleVideoClick(index)}
                whileHover={{ scale: 1.1, backgroundColor: "#f0c14b", color: "#111" }}
                transition={{ duration: 0.3 }}
              >
                Watch Video
              </motion.button>
            </div>
            <motion.div 
              className="main-image-container" 
              initial={{ opacity: 0, scale: 0.9 }} 
              animate={{ opacity: 1, scale: 1 }}
              transition={{ type: "spring", stiffness: 100, delay: 0.4 }}
            >
              {productStates[index]?.isVideo ? (
                <motion.video
                  className="current-video"
                  controls
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6 }}
                >
                  <source src={product.videoLink} type="video/mp4" />
                  Your browser does not support the video tag.
                </motion.video>
              ) : (
                <motion.img
                  src={productStates[index]?.selectedImage || product.main360Image}
                  alt={`${product.name} main view`}
                  className="current-frame"
                  initial={{ scale: 0.95, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                />
              )}
            </motion.div>
            <motion.div 
              className="product-text"
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <p>{product.description}</p>
            </motion.div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default StorageSolution;